import styled from 'styled-components';

export const TableWrapper = styled.div`
	border-radius: ${({ theme }) => theme.border.border_radius.br_xl};
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.palette.secondary.white};
	width: 100%;
`;

export const CustomTable = styled.table`
	width: 100%;
	border-collapse: collapse;

	tr {
		border-top: 2px solid ${({ theme }) => theme.palette.secondary.white} !important;
	}

	th,
	td {
		padding: 10px 15px;
	}

	thead {
		background-color: ${({ theme }) => theme.palette.secondary[100]};

		th {
			color: ${({ theme }) => theme.colors.text};
			font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		}

		&:first-child {
			tr {
				&:first-child {
					border-top: none !important;
				}
			}
		}
	}

	tbody {
		background-color: ${({ theme }) => theme.palette.secondary[50]};
	}
`;
